import { createApp } from 'vue'
import App from './App.vue'

// Ace modules/url mapping and language tools extension
// import './components/nodes/processing/components/ace-config'

// 仅挂载 UI。无 UI 模式请通过包导出的 API 在外部手动触发（见 src/index.ts）。
const app = createApp(App)
app.mount('#app')
